<div class="overlay" [@visibilityChanged]="isLoading">
    <i *ngIf="siteConfig && !siteConfig.loadingIconUrl" class="loading-icon loading-icon-font fa fa-cog"></i>
    <img *ngIf="siteConfig?.loadingIconUrl" class="loading-icon" src="{{ siteConfig.loadingIconUrl }}" />
</div>